import React from 'react'

const Loader = () => {
    return (
        <center>
            <div className="loader-position">
                <div className="loading-sector-orange">O</div>
                <div className="loading-sector-lightblue">O</div>
                <div className="loading-sector-purble">P</div>
                <div className="loading-sector-blue">S</div>
            </div>
        </center>

    )
}

export default Loader
